module.exports = __webpack_public_path__ + "static/media/david.464e11e2.png";